import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faChevronCircleRight, faInfoCircle} from '@fortawesome/free-solid-svg-icons';

export const addLineBreak = definition => {
  if (!definition) {
    return null;
  }
  let paragraphs = definition.trim().split('\n\n');
  return (
    <div className="text-with-line-break">
      {paragraphs.map((p, ip) => (
        <p key={ip}>
          {p.split('\n').map((line, il) => (
            <React.Fragment key={il}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </p>
      ))}
    </div>
  );
};

const ExpandableSection = ({
  title,
  ingressProps,
  isSectionOpen,
  toggleSection,
  className,
  children,
}) => {
  const documentInformationContentRef = useRef(null);
  const [isInitialState, setIsInitialState] = useState(true);

  useEffect(() => {
    const documentInformationContent = documentInformationContentRef.current;
    const expandableTextBoxes = documentInformationContent.querySelectorAll(
      '.expandable-text-box'
    );

    const observers = Array.from(expandableTextBoxes).map(textBox => {
      const observer = new ResizeObserver(() => {
        if (isSectionOpen) {
          documentInformationContent.style.transition = 'none';
          documentInformationContent.style.maxHeight = `${documentInformationContent.scrollHeight}px`;
          documentInformationContent.style.transition = '';
        }
      });
      observer.observe(textBox);
      return observer;
    });

    return () => {
      observers.forEach((observer, index) => {
        observer.unobserve(expandableTextBoxes[index]);
      });
    };
  }, [isSectionOpen]);

  useEffect(() => {
    if (isSectionOpen) {
      documentInformationContentRef.current.style.maxHeight = `${documentInformationContentRef.current.scrollHeight}px`;
    } else {
      documentInformationContentRef.current.style.maxHeight = '0';
    }
  }, [isSectionOpen]);

  const contentClassName =
    isInitialState && !isSectionOpen
      ? 'document-information-expander-content-initial-collapsed'
      : 'document-information-expander-content';

  return (
    <div className={className}>
      <div className="document-information-section">
        <div
          className="document-information-top show-as-clickable dark underline-dark"
          onClick={() => {
            toggleSection();
            setIsInitialState(false);
          }}
        >
          <div className={`expander-icon ${isSectionOpen ? 'expanded' : ''}`}>
            <FontAwesomeIcon icon={faChevronCircleRight} />
          </div>
          <h4>{title}</h4>
        </div>
        <SectionIngress {...ingressProps} />
      </div>
      <div ref={documentInformationContentRef} className={contentClassName}>
        {children}
      </div>
    </div>
  );
};

const SectionIngress = ({ id, version, date, note }) => {
  return (
      <div className="section-ingress-container">
        {id && (
            <span>
          <b>ID: </b>
              {id}
        </span>
        )}
        <span>
        <b>Version: </b>
          {version}
      </span>
      <span>Last updated: {date}</span>
      {note && (
          <div className="info-icon-wrapper">
            <FontAwesomeIcon title={note} icon={faInfoCircle} />
          </div>
      )}
      </div>
  );
};

/**
 * Simplified DocumentInfoSection for the portal.
 * Uses local useState instead of the global useApp() hook from the sub-app state system.
 */
export const DocumentInfoSection = ({ ingressProps, className, children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const toggleOpen = () => setIsOpen(prev => !prev);

  return (
    <ExpandableSection
      title="DOCUMENT"
      ingressProps={ingressProps}
      isSectionOpen={isOpen}
      toggleSection={toggleOpen}
      className={className}
    >
      {children}
    </ExpandableSection>
  );
};
